import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  > canvas {
    min-height: 400px;
    min-width: 400px;
    max-width: 3000px;
    max-height: 700px;
  }
`